module.exports = __webpack_public_path__ + "media/images/features/6/schedule-3-01f8f637b77d63bc022cddc9d17f43a3.png";